import { Route, Switch } from "react-router";
import ErrorBoundary from "./components/ErrorBoundary";
// routes
import Main from "./Main";
import Contracting from "./Contracting";
import Equipments from "./Equipments";

function App() {
  return (
    <div className="App">
      <Switch>
        <Route path="/contracting">
          <ErrorBoundary>
            <Contracting />
          </ErrorBoundary>
        </Route>
        <Route path="/equipments">
          <ErrorBoundary>
            <Equipments />
          </ErrorBoundary>
        </Route>
        <Route path="/">
          <ErrorBoundary>
            <Main />
          </ErrorBoundary>
        </Route>
      </Switch>
    </div>
  );
}

export default App;
